import React from 'react';
import styled from 'styled-components';

const PlaceholderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${props => props.theme.colors.lightGray};
  color: ${props => props.theme.colors.darkGray};
`;

const PlaceholderIcon = styled.div`
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
  border: 3px solid ${props => props.theme.colors.darkGray};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
`;

const PlaceholderText = styled.p`
  font-size: ${props => props.theme.fontSizes.medium};
  font-weight: 500;
`;

const PlaceholderImage = ({ text = "Image" }) => {
  return (
    <PlaceholderContainer>
      <PlaceholderIcon>
        <span>📷</span>
      </PlaceholderIcon>
      <PlaceholderText>{text}</PlaceholderText>
    </PlaceholderContainer>
  );
};

export default PlaceholderImage; 